import { useCallback } from 'react';
import { appRoutes, ROUTING_TAB } from '../../constants/appRoutes';
import useSweepNavigate from '../../navigation-utils/useSweepNavigate';
import { useSweepParams } from '../../navigation-utils/useSweepParams';
import { readableUUID } from '../../navigation-utils/readableUUID';
export enum RoutingTabs {
  assignment = 'assignment',
  scheduled = 'scheduled',
  members = 'members',
  groups = 'groups',
  territories = 'territories',
}

export const useRoutingTabs = () => {
  const { routingTab } = useSweepParams<{
    routingTab: RoutingTabs;
    crmOrgId: string;
  }>();
  const { navigate } = useSweepNavigate();

  const changeTab = useCallback(
    (destinationTab: RoutingTabs, crmOrgId: string) => {
      navigate(
        `${appRoutes.routing.route}/${readableUUID(crmOrgId)}/${ROUTING_TAB}/${destinationTab}`,
        {
          replace: true,
        },
      );
    },
    [navigate],
  );
  const clearTab = useCallback(
    (crmOrgId: string) => {
      navigate(`${appRoutes.routing.route}/${readableUUID(crmOrgId)}`, { replace: true });
    },
    [navigate],
  );

  return {
    routingTab,
    changeTab,
    clearTab,
  };
};
